(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cm-bought-together"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cm-bought-together')) {
    customElements.define(
      'cm-bought-together',
      class extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          const root = this.dataset.root || '/';
          this.root = root.endsWith('/') ? root : `${root}/`;
          this.btn = this.querySelector('[data-cm-fbt-add]');
          this.label = this.querySelector('[data-cm-fbt-label]');
          this.addEventListener('change', () => this.update());
          this.btn.addEventListener('click', () => this.add());
          if (this.querySelector('template[data-cm-fbt-fetch]')) this.loadRelated();
          else this.update();
        }

        money(cents) {
          const [int, dec] = (cents / 100).toFixed(2).split('.');
          const dots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          const commas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return (this.dataset.moneyFormat || '{{amount_with_comma_separator}} lei').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
            k === 'amount_with_comma_separator' ? `${dots},${dec}` : k === 'amount_no_decimals' ? commas : `${commas}.${dec}`
          );
        }

        checked() {
          return [...this.querySelectorAll('input[data-variant]')].filter((i) => i.checked);
        }

        update() {
          const items = this.checked();
          const total = items.reduce((s, i) => s + +i.dataset.price, 0);
          this.label.textContent =
            items.length > 1 ? `Adaugă ${items.length} produse în coș · ${this.money(total)}` : `Adaugă în coș · ${this.money(total)}`;
        }

        async loadRelated() {
          try {
            const url = `${this.root}recommendations/products.json?product_id=${this.dataset.productId}&limit=6&intent=related`;
            const data = await (await fetch(url)).json();
            const list = this.querySelector('[data-cm-fbt-list]');
            const picks = (data.products || [])
              .filter((p) => p.available && String(p.id) !== this.dataset.productId)
              .slice(0, +this.dataset.limit || 2);
            picks.forEach((p) => {
              const v = p.variants.find((x) => x.available) || p.variants[0];
              const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=120` : '';
              const li = document.createElement('li');
              li.className = 'cm-fbt__item';
              li.innerHTML = `<label class="cm-fbt__row">
                <input type="checkbox" checked data-variant="${v.id}" data-price="${v.price}">
                <span class="cm-fbt__img">${img ? `<img src="${img}" alt="" width="56" height="56" loading="lazy">` : ''}</span>
                <span class="cm-fbt__info">
                  <a class="cm-fbt__name" href="${p.url}"></a>
                  <span class="cm-fbt__price">${this.money(v.price)}</span>
                </span></label>`;
              li.querySelector('.cm-fbt__name').textContent = p.title;
              list.appendChild(li);
            });
            if (picks.length) {
              this.btn.hidden = false;
              this.update();
            }
          } catch (e) {}
        }

        async add() {
          const items = this.checked().map((i) => ({ id: +i.dataset.variant, quantity: 1 }));
          const error = this.querySelector('[data-cm-fbt-error]');
          const sections = [...document.querySelectorAll('cart-items-component')]
            .map((el) => el.dataset.sectionId)
            .filter(Boolean);
          this.btn.disabled = true;
          error.hidden = true;
          try {
            const res = await fetch(`${this.root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: items.reverse(), sections: sections.join(',') }),
            });
            const data = await res.json();
            if (!res.ok || data.status) throw new Error(data.description || data.message || 'Eroare');
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: {},
                  sourceId: 'cm-bought-together',
                  data: { source: 'cm-bought-together', itemCount: items.length, sections: data.sections },
                },
              })
            );
            const drawer = document.querySelector('cart-drawer-component');
            if (drawer && !drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') drawer.open();
            else if (!drawer) window.location.href = `${this.root}cart`;
            this.label.textContent = 'Adăugate în coș ✓';
            setTimeout(() => this.update(), 2200);
          } catch (e) {
            error.textContent = `Nu am putut adăuga produsele: ${e.message}`;
            error.hidden = false;
          } finally {
            this.btn.disabled = false;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cm-free-shipping"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__cmShipInit) return;
    window.__cmShipInit = true;

    const money = (cents, format) => {
      const [int, dec] = (cents / 100).toFixed(2).split('.');
      const dots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      const commas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return (format || '{{amount_with_comma_separator}} lei').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
        k === 'amount_with_comma_separator' ? `${dots},${dec}` : k === 'amount_no_decimals' ? commas : `${commas}.${dec}`
      );
    };

    const render = (total) => {
      document.querySelectorAll('[data-cm-ship]').forEach((el) => {
        const shipAt = +el.dataset.shipAt;
        const giftAt = +el.dataset.giftAt;
        const goal = giftAt > shipAt ? giftAt : shipAt;
        const fmt = el.dataset.moneyFormat;
        const fill = (t, amt) => t.replace('[suma]', `<strong>${money(amt, fmt)}</strong>`);
        let html;
        if (total < shipAt) html = fill(el.dataset.tShip, shipAt - total);
        else if (giftAt > shipAt && total < giftAt) html = fill(el.dataset.tGift, giftAt - total);
        else html = el.dataset.tDone;
        el.querySelector('[data-cm-ship-text]').innerHTML = html;
        el.querySelector('[data-cm-ship-fill]').style.width = `${Math.min(100, (total / goal) * 100)}%`;
      });
    };

    const refresh = async () => {
      if (!document.querySelector('[data-cm-ship]')) return;
      try {
        const cart = await (await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart.js`)).json();
        render(cart.total_price);
      } catch (e) {}
    };

    document.addEventListener('cart:update', () => setTimeout(refresh, 150));
    // Pagina poate fi servită din cache (back/forward) cu un coș mai vechi
    window.addEventListener('pageshow', (e) => e.persisted && refresh());
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cm-rating"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-cm-rating]');
    if (!link) return;
    const target = document.querySelector('.jdgm-review-widget, .jdgm-rev-widg, #judgeme_product_reviews, .jdgm-widget');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cm-shades"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-cm-shades-toggle]');
    if (!btn) return;
    const wrap = btn.closest('[data-cm-shades]');
    const open = wrap.classList.toggle('is-collapsed') === false;
    btn.setAttribute('aria-expanded', open);
    btn.querySelector('[data-more]').hidden = open;
    btn.querySelector('[data-less]').hidden = !open;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["palette-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('palette-builder')) {
    class PaletteBuilder extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.slots = parseInt(this.dataset.slots, 10) || 9;
        this.paletteVariant = this.dataset.paletteVariant;
        this.palettePrice = parseInt(this.dataset.palettePrice, 10) || 0;
        this.moneyFormat = this.dataset.moneyFormat || '{{amount_with_comma_separator}} lei';
        this.storeKey = 'pb:' + this.dataset.productId + ':' + this.slots;
        this.filter = 'all';
        this.query = '';
        this.selection = [];
        this.shades = new Map();

        this.slotEls = Array.from(this.querySelectorAll('[data-slot]'));
        this.itemEls = Array.from(this.querySelectorAll('.pb__item'));
        this.querySelectorAll('[data-swatch]').forEach((btn) => {
          const d = btn.dataset;
          this.shades.set(d.id, {
            id: d.id,
            code: d.code,
            name: d.name,
            img: d.img,
            price: parseInt(d.price, 10) || 0,
            compare: parseInt(d.compare, 10) || parseInt(d.price, 10) || 0,
            max: parseInt(d.max, 10),
            btn,
            badge: btn.querySelector('[data-badge]'),
          });
        });

        this.ui = {
          label: this.querySelector('[data-progress-label]'),
          bar: this.querySelector('[data-progress-bar]'),
          clear: this.querySelector('[data-action="clear"]'),
          random: this.querySelector('[data-action="random"]'),
          cta: this.querySelector('[data-action="add"]'),
          ctaLabel: this.querySelector('[data-cta-label]'),
          shadesCount: this.querySelector('[data-shades-count]'),
          shadesTotal: this.querySelector('[data-shades-total]'),
          grandTotal: this.querySelector('[data-grand-total]'),
          savedRow: this.querySelector('[data-saved-row]'),
          saved: this.querySelector('[data-saved]'),
          error: this.querySelector('[data-error]'),
          empty: this.querySelector('[data-empty]'),
          search: this.querySelector('[data-search]'),
        };

        this.renderCounts();
        this.restore();

        this.addEventListener('click', this.onClick.bind(this));
        this.ui.search?.addEventListener('input', (e) => {
          this.query = e.target.value.trim().toLowerCase();
          this.applyFilter();
        });

        this.render();
      }

      /* ---------- events ---------- */

      onClick(event) {
        const swatch = event.target.closest('[data-swatch]');
        if (swatch) return this.add(swatch.dataset.id);

        const slot = event.target.closest('[data-slot]');
        if (slot) return this.removeAt(parseInt(slot.dataset.slot, 10));

        const chip = event.target.closest('[data-filter]');
        if (chip) {
          this.filter = chip.dataset.filter;
          this.querySelectorAll('[data-filter]').forEach((c) => {
            const on = c === chip;
            c.classList.toggle('is-active', on);
            c.setAttribute('aria-selected', on);
          });
          return this.applyFilter();
        }

        const action = event.target.closest('[data-action]')?.dataset.action;
        if (action === 'clear') {
          this.selection = [];
          this.render();
        } else if (action === 'random') {
          this.fillRandom();
        } else if (action === 'add') {
          this.addToCart();
        }
      }

      /* ---------- selection ---------- */

      countOf(id) {
        return this.selection.reduce((n, s) => n + (s === id), 0);
      }

      canAdd(id) {
        const shade = this.shades.get(id);
        return shade && this.selection.length < this.slots && this.countOf(id) < shade.max;
      }

      add(id) {
        if (!this.canAdd(id)) return;
        this.selection.push(id);
        this.render();
      }

      removeAt(index) {
        if (index >= this.selection.length) return;
        this.selection.splice(index, 1);
        this.render();
      }

      fillRandom() {
        const visible = this.itemEls
          .filter((li) => !li.hidden)
          .map((li) => li.querySelector('[data-swatch]').dataset.id);
        const pool = visible.length ? visible : Array.from(this.shades.keys());
        let guard = 500;
        while (this.selection.length < this.slots && guard--) {
          const id = pool[Math.floor(Math.random() * pool.length)];
          if (this.canAdd(id) && (this.countOf(id) === 0 || pool.length < this.slots)) this.selection.push(id);
        }
        this.render();
      }

      /* ---------- filtering ---------- */

      renderCounts() {
        try {
          const counts = JSON.parse(this.querySelector('template[data-counts]').innerHTML);
          Object.entries(counts).forEach(([key, n]) => {
            const el = this.querySelector(`[data-count="${key}"]`);
            if (el) el.textContent = n;
            if (!n && key !== 'all') el?.closest('[data-filter]')?.setAttribute('hidden', '');
          });
        } catch (e) {}
      }

      applyFilter() {
        let shown = 0;
        this.itemEls.forEach((li) => {
          const okFinish =
            this.filter === 'all' ||
            (this.filter === 'sale' ? li.hasAttribute('data-sale') : li.dataset.finish === this.filter);
          const okQuery = !this.query || li.dataset.key.includes(this.query);
          li.hidden = !(okFinish && okQuery);
          if (!li.hidden) shown++;
        });
        this.ui.empty.hidden = shown > 0;
      }

      /* ---------- render ---------- */

      money(cents) {
        const value = (cents / 100).toFixed(2);
        const [int, dec] = value.split('.');
        const withDots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        const withCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
          switch (key) {
            case 'amount_with_comma_separator': return `${withDots},${dec}`;
            case 'amount_no_decimals_with_comma_separator': return withDots;
            case 'amount_no_decimals': return withCommas;
            default: return `${withCommas}.${dec}`;
          }
        });
      }

      render() {
        const filled = this.selection.length;
        const remaining = this.slots - filled;
        const counts = new Map();
        let shadesTotal = 0;
        let saved = 0;

        this.slotEls.forEach((slot, i) => {
          const shade = this.shades.get(this.selection[i]);
          slot.classList.toggle('is-filled', !!shade);
          slot.classList.toggle('is-next', !shade && i === filled);
          slot.disabled = !shade;
          if (shade) {
            slot.style.setProperty('--pb-img', `url("${shade.img}")`);
            slot.setAttribute('aria-label', `Slot ${i + 1}: ${shade.name}. Apasă pentru a elimina`);
          } else {
            slot.style.removeProperty('--pb-img');
            slot.setAttribute('aria-label', `Slot ${i + 1} gol`);
          }
        });

        this.selection.forEach((id) => {
          counts.set(id, (counts.get(id) || 0) + 1);
          shadesTotal += this.shades.get(id).price;
          saved += this.shades.get(id).compare - this.shades.get(id).price;
        });

        this.shades.forEach((shade, id) => {
          const n = counts.get(id) || 0;
          shade.btn.classList.toggle('is-selected', n > 0);
          shade.btn.disabled = remaining === 0 ? n === 0 : n >= shade.max;
          shade.badge.hidden = n < 2;
          shade.badge.textContent = n > 1 ? `×${n}` : '';
        });

        this.ui.label.textContent = `${filled} / ${this.slots} nuanțe alese`;
        this.ui.bar.style.width = `${(filled / this.slots) * 100}%`;
        this.ui.clear.disabled = filled === 0;
        this.ui.random.disabled = remaining === 0;
        this.ui.shadesCount.textContent = filled;
        this.ui.shadesTotal.textContent = this.money(shadesTotal);
        this.ui.grandTotal.textContent = this.money(this.palettePrice + shadesTotal);
        this.ui.savedRow.hidden = saved <= 0;
        this.ui.saved.textContent = `−${this.money(saved)}`;

        const paletteOk = this.dataset.paletteAvailable === 'true';
        this.ui.cta.disabled = remaining > 0 || !paletteOk;
        this.ui.ctaLabel.textContent = !paletteOk
          ? 'Paleta nu este în stoc'
          : remaining === 0
            ? `Adaugă în coș · ${this.money(this.palettePrice + shadesTotal)}`
            : remaining === this.slots
              ? `Alege ${this.slots} nuanțe`
              : `Mai alege ${remaining} ${remaining === 1 ? 'nuanță' : 'nuanțe'}`;
        this.ui.error.hidden = true;

        this.persist();
      }

      /* ---------- persistence ---------- */

      persist() {
        try {
          sessionStorage.setItem(this.storeKey, JSON.stringify(this.selection));
        } catch (e) {}
      }

      restore() {
        try {
          const saved = JSON.parse(sessionStorage.getItem(this.storeKey) || '[]');
          saved.forEach((id) => {
            if (this.canAdd(id)) this.selection.push(id);
          });
        } catch (e) {}
      }

      /* ---------- cart ---------- */

      async addToCart() {
        if (this.selection.length !== this.slots) return;
        const { cta, ctaLabel, error } = this.ui;
        const label = `Paletă Custom ${this.slots}`;
        const paletteId = Math.random().toString(36).slice(2, 7).toUpperCase();

        const counts = new Map();
        this.selection.forEach((id) => counts.set(id, (counts.get(id) || 0) + 1));
        const shadeList = Array.from(counts, ([id, n]) => this.shades.get(id).code + (n > 1 ? ` ×${n}` : '')).join(', ');

        // Paleta e trimisă ultima ca să apară prima în coș (Shopify afișează ultimele produse adăugate sus).
        const items = [
          ...Array.from(counts, ([id, n]) => ({
            id: Number(id),
            quantity: n,
            properties: { 'Aparține de': label, _palette_id: paletteId },
          })).reverse(),
          {
            id: Number(this.paletteVariant),
            quantity: 1,
            properties: { Tip: label, 'Nuanțe': shadeList, _palette_id: paletteId },
          },
        ];

        const sections = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);

        cta.classList.add('is-loading');
        cta.disabled = true;
        error.hidden = true;

        try {
          const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items, sections: sections.join(',') }),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'Eroare');

          this.selection = [];
          this.render();

          cta.classList.remove('is-loading');
          cta.classList.add('is-done');
          ctaLabel.textContent = 'Paleta a fost adăugată ✓';
          setTimeout(() => {
            cta.classList.remove('is-done');
            this.render();
          }, 2200);

          if (this.dataset.redirect === 'true') {
            window.location.href = `${root}cart`;
            return;
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: this.id,
                data: {
                  source: 'palette-builder',
                  itemCount: items.reduce((n, i) => n + i.quantity, 0),
                  sections: data.sections,
                },
              },
            })
          );

          // Coșul lateral se deschide singur dacă tema are „auto-open”; altfel îl deschidem noi.
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && !drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') {
            drawer.open();
          } else if (!drawer) {
            window.location.href = `${root}cart`;
          }
        } catch (e) {
          cta.classList.remove('is-loading');
          this.render();
          error.textContent = `Nu am putut adăuga paleta în coș: ${e.message}. Verifică stocul nuanțelor alese.`;
          error.hidden = false;
        }
      }
    }

    customElements.define('palette-builder', PaletteBuilder);
  }
  } catch(e) { console.error(e); }
})();

})();
